import React from 'react';
import BreadCrumb from '../../../components/common/BreadCrumb';
import { Row, Col } from 'react-bootstrap';
import Error404 from '../../Error/404';
import {
    useEnquiryHistory,
    SchoolProfileCard,
    EnquiryStatusCard,
    FollowUpTimelineCard
} from './EnquiryHistory';

const EnquiryHistroy = () => {
    const {
        report,
        refershReport,
        trialStatus,
        latestFollowup,
        trialEndDate
    } = useEnquiryHistory();

    if (!report) {
        return <Error404 />;
    }

    return (
        <>
            <BreadCrumb title="History" prevPage="Enquiry" prevPath="/enquiry" />
            <Row className="g-3">
                {/* Left Column: School Profile Details & Avatar */}
                <Col lg={4} xs={12}>
                    <SchoolProfileCard report={report} />
                </Col>

                {/* Right Column: Status Details & Follow Up History */}
                <Col lg={8} xs={12}>
                    <EnquiryStatusCard
                        report={report}
                        trialStatus={trialStatus}
                        latestFollowup={latestFollowup}
                        trialEndDate={trialEndDate}
                    />

                    <FollowUpTimelineCard
                        report={report}
                        refershReport={refershReport}
                    />
                </Col>
            </Row>
        </>
    );
};

export default EnquiryHistroy;